<template>
  <div
    class="wordcloud-container"
    :style="{ width: containerWidth, height: containerHeight }"
  >
    <VueWordCloud
      :words="formattedWords"
      :spacing="0.4"
      :font-size-ratio="Number(5)"
      :font-weight="([, weight]) =>
        weight >= wordWeightGroupBoundaries[0] ? '900'
        : weight >= wordWeightGroupBoundaries[1] ? '700'
        : weight >= wordWeightGroupBoundaries[2] ? '600'
        : weight >= wordWeightGroupBoundaries[3] ? '400'
        : '400'
      "
      :color="([, weight]) =>
        weight >= wordWeightGroupBoundaries[0] ? '#172542'
        : weight >= wordWeightGroupBoundaries[1] ? '#98c1dd'
        : weight >= wordWeightGroupBoundaries[2] ? '#172542'
        : weight >= wordWeightGroupBoundaries[3] ? '#98c1dd'
        : '#172542'
      "
      font-family="Montserrat"
      class="wordcloud"
    >
    </VueWordCloud>
  </div>
</template>

<script>
import { percentageFilter, truncateFilter } from '@/utils/filters'
import VueWordCloud from 'vuewordcloud';

export default {
  name: 'BaseBubbleWord',

  filters: {
    percentage: percentageFilter,
    truncate: truncateFilter
  },

  props: {
    dataset: Array,
    showPercentage: Boolean
  },

  computed: {
    formattedWords () {
      let formattedWords = this.dataset.map(item => [item.word, item.percentage])
      formattedWords = formattedWords.sort((a, b) => {return a[1] - b[1]})
      return formattedWords
    },

    containerWidth () {
      const scaleFactor = this.getLogScaleFactor(this.dataset.length, 85);
      return `${scaleFactor}%`;
    },

    containerHeight () {
      const scaleFactor = this.getLogScaleFactor(this.dataset.length, 300);
      return `${scaleFactor}px`;
    },

    wordWeightGroupBoundaries () {
      const wordWeightGroupBoundaries = this.getGroupBoundaries(this.formattedWords, 5)
      return wordWeightGroupBoundaries
    },
  },

  methods: {
    getTooltip (item) {
      return this.showPercentage
        ? `${item.word} - ${this.$filters.percentage(item.percentage)}`
        : item.word
    },

    /**
     * This method helps in creating a balanced visual representation of the size of the
     * wordcloud container by using a logarithmic scale factor, which is helpful to adjust
     * when there are only a few words in the dataset.
     *
     * @param {number} length - The length of the dataset or the number of elements to represent.
     * @param {number} max - The maximum scale factor limit.
     * @return {number} - The calculated scale factor, not exceeding the provided maximum.
    */
    getLogScaleFactor (length, max) {
      // Base length for the max size
      const baseLength = 20;

      // This constant adjusts the curve to ensure that length 20 returns scaleFactor 1
      const adjustmentFactor = Math.log(baseLength);

      // Use a logarithmic scale factor that approaches 1 as the length approaches the base length
      const scaleFactor = Math.log(length + 1) / adjustmentFactor;

      // Ensure that the scale factor never exceeds 1
      return Math.min(scaleFactor, 1) * max;
    },

    getGroupBoundaries(dataArray, groupCount) {
      dataArray.sort((a, b) => a[1] - b[1]);

      let min = dataArray[0][1];
      let max = dataArray[dataArray.length - 1][1];

      let totalRange = max - min;
      let interval = totalRange / groupCount;

      // Lowest boundary not necessary, therefore not included
      let boundaries = [];
      for (let i = 1; i < groupCount; i++) {
        boundaries.push(max - i * interval);
      }

      return boundaries;
    }
  },

  components: {
    VueWordCloud
  },
}
</script>

<style lang="scss" scoped>
.wordcloud-container {
  margin: auto;

  .wordcloud {
    width: auto;
    height: auto;
  }
}
</style>
